class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
          document.dispatchEvent(new CustomEvent('cartdrawer:rendered'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    parsedState = parsedState || {};
    this.productId = parsedState.id;
    const sections = parsedState.sections;
    if (sections) {
      this.applySections(sections);
      this.open();
      return;
    }
    this.refreshFromServer();
  }

  applySections(sections) {
    this.getSectionsToRender().forEach((section) => {
      const root = document.getElementById(section.id);
      if (!root || !sections[section.id]) return;
      const html = this.getSectionInnerHTML(sections[section.id], section.selector);
      if (html != null) root.innerHTML = html;
    });
    document.dispatchEvent(new CustomEvent('cartdrawer:rendered'));
  }

  refreshFromServer() {
    const url = this.dataset.url || `${(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'}?section_id=mini-cart`;
    const sep = url.indexOf('?') >= 0 ? '&' : '?';
    return fetch(`${url}${sep}_=${Date.now()}`, { credentials: 'same-origin', cache: 'no-store' })
      .then((response) => response.text())
      .then((html) => {
        const inner = this.getSectionInnerHTML(html, '.shopify-section');
        const root = document.getElementById('mini-cart');
        if (root && inner != null) root.innerHTML = inner;
        document.dispatchEvent(new CustomEvent('cartdrawer:rendered'));
        this.open();
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return null;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}


customElements.define('mini-cart', MiniCart);

(function refreshMiniCartAfterAdd() {
  function refresh() {
    if (window.__araceliGwpBusy) return;
    const mini = document.querySelector('mini-cart');
    if (mini && typeof mini.refreshFromServer === 'function') mini.refreshFromServer();
  }
  function schedule() {
    setTimeout(refresh, 400);
    setTimeout(refresh, 1200);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('.product-form__submit, button[name="add"]')) schedule();
  }, true);
  document.addEventListener('cart:updated', schedule);
})();
